// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__J5x1Z","calendarButtons":"ClockData_calendarButtons__3iSGF"};